export default __webpack_public_path__ + "static/media/Mee.57f23ae4.png";